import { object, string } from 'yup';

import { IP_TYPE } from 'enum/ip';

export const validationSchema = object().shape({
  name: string()
    .trim()
    .max(250, 'Name cannot be more than 250 characters.')
    .min(3, 'Name cannot be less than 3 characters.')
    .required('Name is required'),
  type: string().oneOf(Object.values(IP_TYPE), 'Invalid IP type').required('IP Type is required'),
  description: string().optional().max(255, 'Description cannot be more than 255 characters'),
});
